export const FILTERS = Object.freeze({
  brand: {
    id: 'brandCd',
    name: '브랜드별',
  },
  category: {
    id: 'category',
    name: '카테고리',
  },
  property: {
    id: 'property',
    name: '속성',
  },
  deliveryType: {
    id: 'drvTy',
    name: '배송유형',
  },
  goodsType: {
    id: 'goodsType',
    name: '상품유형',
  },
  star: {
    id: 'revwStsc',
    name: '별점',
  },
  price: {
    id: 'price',
    name: '가격대',
  },
  age: {
    id: 'age',
    name: '연령',
  },
})
